import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagicWandSparkles = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 1.5,
			y1: 22.5,
			x2: 17.76,
			y2: 6.24
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 16.8,
			y1: .5,
			x2: 16.8,
			y2: 4.33
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 16.8,
			y1: 10.07,
			x2: 16.8,
			y2: 13.89
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 10.11,
			y1: 7.2,
			x2: 13.93,
			y2: 7.2
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 19.67,
			y1: 7.2,
			x2: 23.5,
			y2: 7.2
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12.07,
			y1: 2.46,
			x2: 14.78,
			y2: 5.17
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 18.83,
			y1: 9.22,
			x2: 21.54,
			y2: 11.93
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 18.83,
			y1: 5.17,
			x2: 21.54,
			y2: 2.46
		})
	]
});
const ForwardRef = forwardRef(SvgMagicWandSparkles);
export default ForwardRef;
